import { useLocation } from 'react-router';
import { authorityOpticStorage } from '../../../areas/citizen/authority/services/authority-optic-storage';
import { OmnibarCitizenArea, OmnibarContext } from '../omnibar-interfaces';

const contextRegEx = /\/(?<context>citizen|company)\/(?:(?<citizenArea>authority|serviceprovider)\/)?(?<contextId>[a-z0-9-]{36})?\/(?<tab>[a-z-]+)?/i;
const serviceProviderUnitParam = 'spuid';

export default function useOmnibarContext() {
  const { pathname, search } = useLocation();
  const match = pathname.match(contextRegEx);
  const params = new URLSearchParams(search);
  const serviceProviderUnitId = params.get(serviceProviderUnitParam) || undefined;
  const opticId = authorityOpticStorage.getActiveOpticId();
  if (match && match.groups) {
    const { context, citizenArea, contextId, tab }: { context?: OmnibarContext; citizenArea?: string; contextId?: string; tab?: string } = match.groups;
    return { context, citizenArea: toCitizenArea(context, citizenArea), contextId, tab, serviceProviderUnitId, opticId };
  }
  return { serviceProviderUnitId, opticId };
}

function toCitizenArea(context: OmnibarContext | undefined, citizenArea: string | undefined): OmnibarCitizenArea | undefined {
  if (context !== 'citizen') return undefined;
  return citizenArea?.toLowerCase() === 'serviceprovider' ? 'serviceprovider' : 'authority';
}
